import {
	bigintize,
	isAddress,
	isBlockHash,
	getContractAddress,
	getTokenDefinition,
	type Address,
	type ValidChainId,
	type ContractName,
} from "@bracket/chainography";

import type { TokenIdentifier, } from "@bracket/types";

import type {
	Config,
} from "@wagmi/core";

import { allowance, } from "./allowance";
import { approve, } from "./approve";



export declare type AssertAllowance = {
	amount: bigint | number;
	spender: ContractName | Address;
	token: TokenIdentifier;
	config?: Config;
	chainId?: ValidChainId;
}



/**
 * Asserts that a given spender has sufficient allowance to spend tokens
 * @param {AssertAllowance} params - The parameters for asserting allowance
 * @param {bigint|number} params.amount - The amount of tokens to check/approve
 * @param {ContractName|Address} params.spender - The address or contract name to approve
 * @param {TokenIdentifier} params.token - The token to check/approve
 * @param {Config} [params.config] - Optional wagmi config
 * @param {ValidChainId} [params.chainId=1] - The chain ID to operate on
 * @returns {Promise<boolean>} True if allowance exists or was approved
 * @throws {Error} If spender is invalid or approval fails
 */
export const assertAllowance = async ({
	amount,
	spender,
	token,
	config,
	chainId = 1,
}:AssertAllowance ): Promise<boolean> => {

	try {

		spender = isAddress(spender) ? spender : getContractAddress(spender);

		if(isAddress(spender)) {
			const tok = getTokenDefinition(token);
			const bAmount = typeof amount === "bigint" ? amount : bigintize(amount, tok);
			const allowed = await allowance({ token: tok, spender, config, });
			if(allowed >= bAmount) {
				return true;
			}
			const hash = await approve({ spender, amount:bAmount, token: tok, config, })
			if(isBlockHash(hash)) {
				return true;
			}
			throw new Error("did not recieve a block hash")
		}
		throw new Error(`unknown spender "${spender}"`);
	}
	catch(err) { 
		throw new Error(`@bracket/contractor::assertAllownace has failed - ${err.message}`);
	}
}
